import { createStore } from "vuex";
import auth from "./modules/auth";
import company from "./modules/company";
import product from "./modules/product";
import common from "./modules/common";

export default createStore({
  modules: {
    auth,
    company,
    product,
    common,
  },
  state: {
    loading: false,
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    setLoading({ commit }, loading) {
      commit("SET_LOADING", loading);
    },
  },
  getters: {
    loading: (state) => state.loading,
  },
});
